import { createSlice } from "@reduxjs/toolkit";

export const userSlice = createSlice({
  name: "user",
  initialState: {
    getUsersLoading: false,
    getUsersError: false,
    getUsersData: null,
    getUsersMessage: "",
  },
  reducers: {
    onGetUsers: (state) => ({
      ...state,
      getUsersLoading: true,
      getUsersError: false,
      getUsersData: null,
      getUsersMessage: "",
    }),
    onGetUsersSuccess: (state, { payload }) => {
      const { data = null, message = "" } = payload ?? {};
      return {
        ...state,
        getUsersLoading: false,
        getUsersError: false,
        getUsersData: data,
        getUsersMessage: message,
      };
    },
    onGetUsersError: (state, { payload }) => {
      const { message = "Failed to load users" } = payload ?? {};
      return {
        ...state,
        getUsersLoading: false,
        getUsersError: true,
        getUsersData: null,
        getUsersMessage: message,
      };
    },
    onGetUsersReset: (state) => ({
      ...state,
      getUsersLoading: false,
      getUsersError: false,
      getUsersData: null,
      getUsersMessage: "",
    }),
    onPostUsers: (state) => ({
      ...state,
      postUsersLoading: true,
      postUsersError: false,
      postUsersData: null,
      postUsersStatusCode: null,
      postUsersMessage: "",
    }),
    onPostUsersSuccess: (state, { payload }) => {
      const { data = null, message = "", status_code = 200 } = payload ?? {};
      const code = status_code != null ? String(status_code) : "200";
      return {
        ...state,
        postUsersLoading: false,
        postUsersError: false,
        postUsersData: data,
        postUsersStatusCode: code,
        postUsersMessage: message,
      };
    },
    onPostUsersError: (state, { payload }) => {
      ;
      const { message = "Failed to create user", status_code = 400 } = payload ?? {};
 
      return {
        ...state,
        postUsersLoading: false,
        postUsersError: true,
        postUsersData: null,
        postUsersStatusCode: status_code,
        postUsersMessage: message,
      };
    },
    onPostUsersReset: (state) => ({
      ...state,
      postUsersLoading: false,
      postUsersError: false,
      postUsersData: null,
      postUsersMessage: "",
      postUsersStatusCode: null,
    }),
  },
});

export const {
  onGetUsers,
  onGetUsersSuccess,
  onGetUsersError,
  onGetUsersReset,
  onPostUsers,
  onPostUsersSuccess,
  onPostUsersError,
  onPostUsersReset,
} = userSlice.actions;

export default userSlice.reducer;
